import {
  rating_styles_default
} from "./chunk.CJSV6Y6D.js";
import {
  SlRating
} from "./chunk.IBH67KHZ.js";
import {
  i
} from "./chunk.LP7FQRAP.js";
import {
  o as o2
} from "./chunk.7ZTMBV6K.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/rating/rating.ts
import { t } from "i18next";
var FadvRating = class extends SlRating {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "help-text", "label");
    this.label = "";
    this.helpText = "";
  }
  renderInactiveSymbols(counter, displayValue) {
    return $`<span class="rating__symbols rating__symbols--inactive">${counter.map((index) => {
      return $`<span class=${o({
        rating__symbol: true,
        "rating__symbol--hover": this["isHovering"] && Math.ceil(displayValue) === index + 1
      })} role="presentation" @mouseenter=${this.handleMouseEnter} >${o2(this.getSymbol(index + 1))}</span>`;
    })}</span>`;
  }
  renderActiveSymbols(counter, displayValue) {
    return $`<span class="rating__symbols rating__symbols--indicator">${counter.map((index) => {
      return $`<span class=${o({
        rating__symbol: true,
        "rating__symbol--hover": this["isHovering"] && Math.ceil(displayValue) === index + 1
      })} style=${i({
        clipPath: displayValue > index + 1 ? "none" : `inset(0 ${100 - (displayValue - index) / 1 * 100}% 0 0)`
      })} role="presentation" >${o2(this.getSymbol(index + 1))}</span>`;
    })}</span>`;
  }
  render() {
    const counter = Array.from(Array(this.max).keys());
    const hasLabel = !!this.label || this.hasSlotController.test("label");
    const hasHelpText = !!this.helpText || this.hasSlotController.test("help-text");
    let displayValue = 0;
    if (this.disabled || this.readonly) {
      displayValue = this.value;
    } else {
      displayValue = this["isHovering"] ? this["hoverValue"] : this.value;
    }
    return $`<div part="form-control" class=${o({
      "form-control": true,
      "form-control--medium": true,
      "form-control--has-label": hasLabel,
      "form-control--has-help-text": hasHelpText
    })} ><label part="form-control-label" class="form-control__label" aria-hidden=${hasLabel ? "false" : "true"} id="label"><slot name="label">${this.label}</slot></label><div><div part="base" role="slider" class=${o({
      rating: true,
      "rating--readonly": this.readonly,
      "rating--disabled": this.disabled
    })} aria-label=${l(!hasLabel ? t("components:rating.rating") : void 0)} aria-labelledby=${l(hasLabel ? "label" : void 0)} aria-disabled=${this.disabled ? "true" : "false"} aria-readonly=${this.readonly ? "true" : "false"} aria-valuenow=${this.value} aria-valuemin=${0} aria-valuemax=${this.max} tabindex=${this.disabled ? "-1" : "0"} @click=${this.handleClick} @keydown=${this.handleKeyDown} @mouseenter=${this.handleMouseEnter} @touchstart=${this.handleTouchStart} @mouseleave=${this.handleMouseLeave} @touchend=${this.handleTouchEnd} @mousemove=${this.handleMouseMove} @touchmove=${this.handleTouchMove} >${this.renderInactiveSymbols(counter, displayValue)}${this.renderActiveSymbols(counter, displayValue)}</div></div><div part="form-control-help-text" id="help-text" class="form-control__help-text" aria-hidden=${hasHelpText ? "false" : "true"}><slot name="help-text">${this.helpText}</slot></div></div>`;
  }
};
FadvRating.styles = rating_styles_default;
__decorateClass([
  e()
], FadvRating.prototype, "label", 2);
__decorateClass([
  e({ attribute: "help-text" })
], FadvRating.prototype, "helpText", 2);
FadvRating = __decorateClass([
  n("fadv-rating")
], FadvRating);

export {
  FadvRating
};
